import { useMemo } from 'react'

import type { Action, DynamicActionsProps } from '../types'

type ActionsFilterReturn = {
  visibleActions: Array<Action>
  hiddenActions: Array<Action>
}

export const useActionsFilter = (
  actions: DynamicActionsProps['actions'],
  actionFilter: DynamicActionsProps['actionFilter'],
): ActionsFilterReturn => {
  const activeActions = useMemo(() => actions?.filter((action) => action.action_name) ?? [], [actions])

  return useMemo(() => {
    const normalizedFilter = typeof actionFilter === 'string' ? actionFilter : { ...actionFilter }

    if (normalizedFilter === 'show_all') {
      return {
        visibleActions: activeActions,
        hiddenActions: [],
      }
    }

    if (normalizedFilter === 'hide_all') {
      return {
        visibleActions: [],
        hiddenActions: activeActions,
      }
    }

    if (typeof normalizedFilter !== 'string') {
      const { visible = [], hidden = [] } = normalizedFilter

      const visibleActions = activeActions.filter(
        (action) => visible.includes(action.action_name) && !action.hidden && !hidden.includes(action.action_name),
      )

      const hiddenActions = activeActions.filter((action) => !visibleActions.includes(action))

      return { visibleActions, hiddenActions }
    }

    return {
      visibleActions: activeActions,
      hiddenActions: [],
    }
  }, [activeActions, actionFilter])
}
